import axiosWrapper from '../axiosWrapper/axiosWrapper';
import {logError} from '../utils/logger';

const {apiErrorHandler} = require('./api_error_handler/api_error_handler');

const {appStore} = require('../redux/createStore');
const {sleep, logPageActionToSmartlook} = require('../utils/util');

const OKTA_TOKEN_STORAGE = 'okta-token-storage';

let states;
appStore?.subscribe(() => {
  states = appStore.getState().mfaStates;
});

const nonContractUrlArray = [
  'customerInformation',
  'contracts',
  'userDetail',
  'eligibility',
  'offerEnquiry',
  'customerDetails',
  'getCustomerMachineHealth',
];

export const getReduxStateData = (url, params, store) => {
  let stateData;
  if (nonContractUrlArray.indexOf(url.split('?')[0]) > -1) {
    stateData = states[store.stateName];
  } else {
    stateData =
      states[store.stateName] &&
      states[store.stateName][params.contractNumber] &&
      states[store.stateName][params.contractNumber];
  }
  return stateData;
};
export const dispatchReduxStateData = (url, store, params, apiResponse) => {
  if (nonContractUrlArray.indexOf(url.split('?')[0]) > -1) {
    appStore.dispatch(store.actionName(apiResponse));
  } else {
    let stateData =
      states && states[store.stateName] ? states[store.stateName] : {};
    stateData[params.contractNumber] = apiResponse;
    appStore.dispatch(store.actionName(stateData));
  }
};

export const getAPICall = async (url, params, store) => {
  let apiResponse;
  if (store.stateName && states && getReduxStateData(url, params, store)) {
    apiResponse = getReduxStateData(url, params, store);
  } else {
    await axiosWrapper.get(url).then(
      async (response) => {
        if (response.data) {
          apiResponse = response.data;
          if (store.stateName) {
            dispatchReduxStateData(url, store, params, apiResponse);
          }
        } else if (params.isCallBack && response.status === 202) {
          await sleep(2);
          apiResponse = getAPICall(url, params, store);
        }
      },
      (error) => {
        apiResponse = {
          isError: true,
        };
        logError(error);
        logPageActionToSmartlook(null, null, error);
        let oktaTokenStoage =
          localStorage.getItem(OKTA_TOKEN_STORAGE) &&
          JSON.parse(localStorage.getItem(OKTA_TOKEN_STORAGE));
        if (oktaTokenStoage.accessToken) {
          apiErrorHandler(
            error,
            params.errorTag,
            params.hasOwnProperty('redirectToOops')
              ? params.redirectToOops
              : true,
            '/oops'
          );
        }
      }
    );
  }
  return apiResponse ? apiResponse : {};
};

export const postAPICall = async (
  url,
  payload,
  params,
  redirectErrorCallBack
) => {
  let apiResponse = {};
  await axiosWrapper.post(url, payload).then(
    (response) => {
      apiResponse = response && response.data;
    },
    (error) => {
      logError(error);
      logPageActionToSmartlook(null, null, error);
      if (!error.response || error.response.status !== 404) {
        apiErrorHandler(error, params.errorTag);

        if (redirectErrorCallBack) {
          redirectErrorCallBack();
        }
      }
    }
  );
  return apiResponse;
};
